module.exports = __webpack_public_path__ + "static/media/login.7c47751d.png";